exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".after-upload-modal {\n  display: flex;\n  flex-direction: column;\n}\n\n.after-upload-modal .spinner {\n  margin: 0 auto;\n  font-size: 8rem;\n}\n\n.after-upload-modal__text {\n  margin-top: 30rem;\n}\n\n.after-upload-modal__buttons>* {\n  margin-bottom: 4.5rem;\n}\n\n.after-upload-modal__buttons>*:last-child {\n  margin-bottom: 0;\n}\n\n", ""]);

// exports
